import React from "react";
import SolutionsObject from "./SolutionsObject";
import {
  FlipBlock,
  IconBlockVertical,
  MainTitle,
  MetaHelmet,
  TextCarouselSlick,
  TitleParagraphBlock,
  UniversitySlick,
  VerticalCarouselSlick
} from "../UiComponents/ContentBlocks";
import ManageXMainBanner from "../../assets/img/solutions/ManageX_MainBannerImage.jpg";
import manageXLogo from "../../assets/img/solutions/ManageX-MainSolutionLogo.png";
import ScrollAnimation from "react-animate-on-scroll";
import ValueProposition from "../UiComponents/ValueProposition";
import { Link } from "react-router-dom";

import InnerBanner from "../UiComponents/InnerBanner";
import { Grid } from "@mui/material";

export default function Managex() {
  const root = SolutionsObject.ManageX;
  return (
    <React.Fragment>
      <MetaHelmet helmet={root.helmet} />
      <InnerBanner
        patch
        backgroundImage={ManageXMainBanner}
        bannerTitle={root.pageTitle.heading}
        featureParagraph={root.pageTitle.paragraph}
        logo={manageXLogo}
      />

      <ValueProposition
        mainContainerClass="imageContained"
        title={root.whatManageX.title}
        image={root.whatManageX.image}
        paragraph={root.whatManageX.paragraph}
      />
      <section className="sectionContainer xFlipBox bgBlack">
        <div className="container">
          <MainTitle title={root.difference.title} />
        </div>
        <div className="container">
          {root.difference.points.map((item, index) => (
            <FlipBlock
              key={index.toString()}
              title={item.title}
              paragraph={item.paragraph}
              icon={item.icon}
            />
          ))}
        </div>
      </section>
      <ScrollAnimation animateIn="pulse" duration={1} animateOnce={true}>
        <section className="sectionContainer">
          <div className="container">
            <MainTitle title={root.manageXOfferings.title} />
          </div>
          <div className="container">
            <div className="solution-managex-blog-card-main-wrapper">
              {root.manageXOfferings.manageXBlogs.map((item, index) => (
                <div
                  className="solution-managex-blog-card-main-contatier"
                  key={index.toString()}
                >
                  <img src={item.image} alt="manageX logo" className="logo" />
                  {/* <h3>{item.title}</h3> */}
                  <p dangerouslySetInnerHTML={{ __html: item.paragraph }}></p>
                  <Link to={item.link} target="_blank">
                    Learn More
                  </Link>
                </div>
              ))}
            </div>
            <Grid container justifyContent={"center"} alignItems={"center"}>
              <Grid item md={10}>
                <Grid container className="conciergeCon" spacing={3}>
                  <Grid item sm={3}>
                    <img
                      src={root.manageXOfferings.Concierge.image}
                      alt={root.manageXOfferings.Concierge.title}
                    />
                  </Grid>
                  <Grid item sm={9}>
                    <div className="titleConcierge">
                      <div>
                        <img
                          src={root.manageXOfferings.Concierge.logo}
                          alt={root.manageXOfferings.Concierge.title}
                        />
                        <h5>{root.manageXOfferings.Concierge.title}</h5>
                      </div>
                      <div className="iconList">
                        {root.manageXOfferings.Concierge.icons.map(
                          (item, index) => (
                            <img
                              key={index.toString()}
                              src={item}
                              alt={index.toString()}
                            />
                          )
                        )}
                      </div>
                    </div>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: root.manageXOfferings.Concierge.paragraph
                      }}
                    ></p>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </section>
      </ScrollAnimation>

      <VerticalCarouselSlick
        bgBlack
        title={root.Engage.title}
        paragraph={root.Engage.paragraph}
        points={root.Engage.points}
        className="engageManageX"
      />

      <IconBlockVertical
        title={root.capabilities.title}
        paragraph={root.capabilities.paragraph}
        points={root.capabilities.points}
      />

      <ScrollAnimation animateIn="pulse" duration={1} animateOnce={true}>
        <TextCarouselSlick
          bgBlack
          slideScroll={2}
          title={root.quotesCustomers.title}
          points={root.quotesCustomers.point}
        />
      </ScrollAnimation>
      <ScrollAnimation animateIn="pulse" duration={1} animateOnce={true}>
        <UniversitySlick
          title={root.customerStories.title}
          points={root.customerStories.university}
        />
      </ScrollAnimation>
    </React.Fragment>
  );
}
